﻿import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import { ModalMessageType } from '../models/enums';
import { CrudFunctions } from '../utilities/crud-functions';
import { DocumentationConstants } from '../store/documentation-constants';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';

//import { SelectBox } from 'devextreme-react';
//import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { List } from 'devextreme-react/list';

//temp
const templates = [
    { id: 1, name: "Standards Import", description: "Add Standards in Standards Maintenance Form" },
    { id: 2, name: "Compositions Import", description: "Add quick compositions list in Product Planning" },
    { id: 3, name: "User Import", description: "Add user in Users Maintenance Form" },

];


//let key = 1;

export default function ResourcesForm() {
    //const [tickets, setTickets] =
    //  useState<Ticket[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    //key++;

    return (
        <div className="pw-form-container">
            <div id="pb-title-pane">
                <div className="lq-title-bar">
                    <div className="lq-main-title">Resources</div>
                    <div className="title-bar-spacer" />
                    <div className="save-toolbar">

                        <div>
                            <Button className="title-bar-button"
                                text="" icon="arrowleft" type="normal"
                                hint="go back"
                                onClick={goBack} />
                        </div>
                        <div>
                            <NavLink to={`/documentation/${DocumentationConstants.ResourcesForm}`}
                                className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                                <Button className="title-bar-button pw-orange"
                                    text="" icon="help" type="normal"
                                    hint="help and documentation" />
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pw-margin-left-1">
                <div className="lq-sub-title pw-blue">Excel Templates</div>

                <List height="18em"
                    className="dx-listbox"
                    onItemClick={onExcelTemplateItemClick}
                    itemRender={excelTemplatesItemRender}
                    dataSource={templates ? templates : []} />

            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    //needed??
    function onExcelTemplateItemClick(e: any) {
        console.log(e);

    }

    function onDownloadTemplateClick(e: any) {
        console.log(e);

        if (e.element && e.element.id) {
            const matchingTemplate = templates.find(t => t.id = e.element.id);
            const templateName = matchingTemplate ? matchingTemplate.name : "Template";

            downloadTemplate(e.element.id, templateName);
        }
    }

    async function downloadTemplate(templateId: number, templateName: string) {
        if (templateId) {

            await CrudFunctions.getDataBlob(`support/template/${templateId}`)
                .then(blob => {
                    let a = document.createElement("a") as HTMLAnchorElement;
                    document.body.appendChild(a);
                    a.style.display = "none";
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = templateName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Template");
                });
        }
    }

    //navigation

    function goBack() {
        history.back();
    }

    //render

    function excelTemplatesItemRender(e: any) {
        return (
            <div className="flex-col-stretch">
                <div className="pw-list-item-info">
                    <div className="pw-list-item-name">{e.name}</div>
                    <div className="pw-list-item-desc">{e.description}</div>
                </div>
                <div className="pw-list-item-right">
                    <Button type="normal" id={e.id} text="Download"
                        icon="download" className="pw-list-item-download"
                        onClick={onDownloadTemplateClick} />
                </div>
            </div>
        );
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

